import React from 'react';
import PropTypes from 'prop-types';

function ContactSocialCard({ icon, text, socialType = 'default', url }) {
    const getSocialClass = (type) => {
        switch (type) {
            case 'instagram':
                return 'socialInsta';
            case 'facebook':
                return 'socialFacebook';
            case 'whatsapp':
                return 'socialWhatsapp';
            default:
                return 'social';
        }
    };

    return (
        <a href={url} className={`socialCard ${getSocialClass(socialType)}`} target="_blank" rel="noopener noreferrer">
            {icon}
            <p>{text}</p>
        </a>
    );
}

ContactSocialCard.propTypes = {
    icon: PropTypes.element.isRequired,
    text: PropTypes.string.isRequired,
    socialType: PropTypes.string,
    url: PropTypes.string.isRequired,
};


export default ContactSocialCard;